<template>
  <div v-if="menu">
    <div class="card-wrapper" v-if="grades.length>0" :style="`grid-template-columns:repeat(${grid}, 1fr)`">
      <component :is="`${componentName}Pc`" v-for="(card, idx) in grades" :key="'card'+idx" :card="card"></component>
    </div>
    <template v-if="grades1.length>0" >
      <div class="h5 padding-top-40 padding-bottom-16">수동 설치 {{ menu.name }}
        <span class="h5 primary margin-left-4">{{ grades1.length }}</span></div>
      <div class="body2 sub3 margin-bottom-32">기능 추가를 원할 시
        {{ menu.name === '플랫폼 팩' ? '최소 4주의' : '2주 이내의' }}
        작업 기간이 필요합니다. 런치팩 1:1 문의를 통해 신청해주시면 필요한 절차와 세부 설치 일정을 안내해드립니다. </div>

      <div class="card-wrapper" :style="`grid-template-columns:repeat(${grid}, 1fr)`">
        <component :is="`${componentName}Pc`" v-for="(card, idx) in grades1" :key="'card1-'+idx" :card="card"></component>
      </div>
    </template>
  </div>
</template>

<script>
  import CardProductThemePc from "./CardProductThemePc";
  import CardProductPluginPc from "./CardProductPluginPc";
  import CardProductServicePc from "./CardProductServicePc";

  export default {
    name: "ListProductAppMarket",
    components: {
      CardProductThemePc,
      CardProductPluginPc,
      CardProductServicePc
    },
    props: {
      menu: {
        type: Object
      },
      products: {
        type: Array
      },
      shadow: {
        type: Boolean,
        default: false
      },
    },
    created() {
      this.initCard();
    },
    data() {
      return {
        grid: 3
      }
    },
    watch: {
      menu() {
        this.initCard();
      }
    },
    computed: {
      grades() {
        return this.products ? this.products.filter(i => i.grade === 0) : [];
      },
      grades1() {
        return this.products ? this.products.filter(i =>i.grade === 1) : [];
      },
      componentName() {
        const type = {
          '플랫폼 팩': 'Theme',
          '플러그인': 'Plugin',
          '추가서비스': 'Service'
        }[this.menu.name];

        return `CardProduct${type}`;
      },
      boxShadow() {
        return this.shadow ? 'box-shadow: 0px 2px 10px 0 #ccc8c8;' : '';
      }
    },
    methods: {
      initCard() {
        if(this.menu && this.menu.name === '플랫폼 팩') {
          this.grid = 4;
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import 'market_style.styl'

  .card-wrapper
    display grid
    grid-gap 57px 16px
</style>
